export const shortcuts = {
    "Text Formating": {
        "Bold": "Ctrl + B",
        "Italic": "Ctrl + I",
        "Underline": "Ctrl + U"
    },
    "Editing": {
        "Insert Link": "Ctrl + Shift + L",
        "Find and Replace": "Ctrl + Shift + F"
    },
    "Navigation": {
        "See keyboard shortcuts": "Ctrl + /"
    }
}